﻿import React from 'react';
import { useTranslation } from 'react-i18next';

import Table_Head from '@Elements/Table/Table_Head';
import Table_Data from '@Elements/Table/Table_Data';
import {  generate_unique_id } from '@Util/Utils';
import {
    Weekly_Report_Table_Data
} from '@Util/Types';

export default function Weekly_Report_Table(props: Weekly_Report_Table_Data): JSX.Element {
    const [t] = useTranslation();

    function Empty_Table(): JSX.Element {
        return (
            <tr>
                <Table_Data align="left">
                    <span className="Table_Data_Customer_Name">{t('Text.NoTimelogObjectsToShow')}</span>
                </Table_Data>
                <Table_Data align="right">
                    <></>
                </Table_Data>
            </tr>
        )
    }

    function return_hour_letter(val: string): string {
        if (Number.isNaN(parseInt(val)))
            return "";

        return "h";
    }

    return (
        <>
            <div className="Table_Wrapper">
                <table className="Table">
                    <thead>
                        <tr key={generate_unique_id()}>
                            {props?.weeklyReportGrid[0]?.map((o: string): JSX.Element =>
                                <Table_Head
                                    align="left"
                                    text={o}
                                />
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props?.weeklyReportGrid?.isEmpty() ?
                                <Empty_Table /> :
                                props?.weeklyReportGrid?.map((o: string[], i: number): JSX.Element => {
                                    if (i != 0) {
                                        return (
                                            <tr key={generate_unique_id()}>
                                                {o.map((a: string): JSX.Element =>
                                                    <Table_Data
                                                        align="left"
                                                        className="Table_Data_With_Buttons"
                                                    >
                                                        <span>{`${a.replace(".", ",")} ${return_hour_letter(a)}`}</span>
                                                    </Table_Data>
                                                )}
                                            </tr>
                                        )
                                    }
                                })
                        }
                    </tbody>
                </table>
            </div>
        </>
    );
}